import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchAll(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/staffs', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchOne(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/staffs/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    add(ctx, data) {
      return new Promise((resolve, reject) => {
        axios
          .post('/staffs', data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    edit(ctx, data) {
      return new Promise((resolve, reject) => {
        const url = `/staffs/${data.id}`
        axios
          .put(url, data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    del(ctx, id) {
      return new Promise((resolve, reject) => {
        const url = `/staffs/${id}`
        axios
          .delete(url)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

  },
}
